module.exports = __webpack_public_path__ + "static/positive-discipline-for-preschoolers-992cc8ee9eb720d2d0aa0335a98f89db.jpg";